export default {"src":"/_next/static/media/db.77e78deb.svg","height":40,"width":83};